export default {
    state: {
        perms: [],  // 用户角色标识集合
    },
    getters: {

    },
    mutations: {
        setPerms(state, perms){  // 用户角色标识集合
            state.perms = perms;
        }
    },
    actions: {
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js